import { Loader2, type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface PhotoToolbarActionProps {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
  isActive?: boolean;
  isPending?: boolean;
  isDisabled?: boolean;
  isDestructive?: boolean;
  controls?: string;
  title?: string;
}

export function PhotoToolbarAction({
  icon: Icon,
  label,
  onClick,
  isActive,
  isPending,
  isDisabled,
  isDestructive,
  controls,
  title,
}: PhotoToolbarActionProps) {
  return (
    <Button
      variant="ghost"
      aria-expanded={controls ? isActive : undefined}
      aria-controls={controls}
      disabled={isDisabled}
      title={title}
      className={cn(
        "h-auto flex-col gap-0.5 rounded-lg px-2 py-1.5 text-xs",
        isDestructive ? "text-red-400 hover:bg-red-950 hover:text-red-300" : "text-gray-200 hover:bg-gray-800 hover:text-white",
        isActive && "bg-gray-800 text-white",
      )}
      onClick={onClick}
    >
      {isPending ? <Loader2 className="size-4 animate-spin" aria-hidden="true" /> : <Icon className="size-4" aria-hidden="true" />}
      {label}
    </Button>
  );
}
